import { gql, QueryHookOptions, TypedDocumentNode } from "@apollo/client";

import {
  GetCaseBlacklistableIdentifiersRelatedCasesQuery,
  GetCaseBlacklistableIdentifiersRelatedCasesQueryVariables,
} from "src/graphql/anti-fraud/__generated__/graphql";
import { linkedCaseFragment } from "src/graphql/anti-fraud/fragments/LinkedCaseFragment";
import { useFetchQuery } from "src/graphql/utils";
import { mapToLinkedCase } from "src/mappers/case.mappers";

export const getCaseBlacklistableIdentifiersRelatedCasesQuery = gql`
  query GetCaseBlacklistableIdentifiersRelatedCases(
    $id: ID!
    $includeLinkedCaseIdentifiers: Boolean!
  ) {
    case(id: $id) {
      blacklistableIdentifiers(includeLinkedCaseIdentifiers: $includeLinkedCaseIdentifiers) {
        identifier {
          id
        }
        element {
          id
        }
        blacklist {
          code
        }
        linkedCases {
          ...LinkedCaseFragment
        }
      }
    }
  }
  ${linkedCaseFragment}
` as TypedDocumentNode<
  GetCaseBlacklistableIdentifiersRelatedCasesQuery,
  GetCaseBlacklistableIdentifiersRelatedCasesQueryVariables
>;

export const useGetBlacklistableIdentifiersRelatedCasesQuery = (
  options?: QueryHookOptions<
    GetCaseBlacklistableIdentifiersRelatedCasesQuery,
    GetCaseBlacklistableIdentifiersRelatedCasesQueryVariables
  >
) => {
  return useFetchQuery(getCaseBlacklistableIdentifiersRelatedCasesQuery, {
    queryOptions: options,
    uiErrors: {
      fetchError: "FETCH-BLACKLIST-IDENTIFIERS-ERROR",
    },
    isEmpty: (data) => !data?.case?.blacklistableIdentifiers.length,
    toData: (data) =>
      Object.fromEntries(
        data?.case?.blacklistableIdentifiers.map((item) => [
          `${item.identifier.id}-${item.element.id}-${item.blacklist.code}`,
          item.linkedCases.map(mapToLinkedCase),
        ]) ?? []
      ),
  });
};
